module.exports = __webpack_public_path__ + "ida_font01.jpg?2cb48194bc4b6e48a234f16e6bc1bf27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_font01.jpg
// module id = 68
// module chunks = 0